<template>
  <!--悬浮框 确定预定信息-->
  <div class="m-pop-layer">
    <div class="m-flex-row">
      <div class="m-pop-content">
        <div class="m-pop-title">
          <p>确认预定信息</p>
          <a href="javascript:void(0)" @click="closeLayer(1, 0)"></a>
        </div>
        <div class="m-pop-center">
          <div class="m-flex-row m-info">
            <div>姓名</div>
            <div>{{ comdata.name }}</div>
          </div>
          <div class="m-flex-row m-info">
            <div>婚期</div>
            <div v-if="comdata.weddingDate">{{ weddata }}</div>
            <div v-else>未定</div>
          </div>
          <div class="m-flex-row m-info">
            <div>联系电话</div>
            <div>{{ comdata.phone }}</div>
          </div>
          <div class="m-flex-row m-info">
            <div>婚礼服务</div>
            <div>{{ comdata.service }}</div>
          </div>
          <div class="m-flex-row m-info">
            <div>婚礼顾问</div>
            <div>{{ comdata.weddingBroker }}</div>
          </div>
        </div>
        <div class="m-pop-bottom">
          <a
            class="m-btn"
            href="javascript:void(0)"
            @click="goPay"
            style="font-size: 16px;"
            >支付定金 ¥{{ comdata.amount / 100 }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import api from "../../config/api.js";
export default {
  name: "comfirm-info",
  props: ["serData", 'channelType'],
  data: function () {
    return {
      comdata: this.serData[1] || {},
    };
  },
  created: function () {},
  computed: {
    weddata: function () {
      return dayjs(new Date(this.comdata.weddingDate)).format("YYYY年MM月DD日");
    },
  },
  methods: {
    goPay: function () {
      let vm = this;
      // if (vm.comdata.curType == 1) {
      console.log('----------支付跳转问题定位-3', vm.channelType)
      if (vm.channelType == 1) {
        vm.getAjax(
          `${api.PAY_URL}/pay/v2/create/zjPayForWedding`,
          {
            codes: vm.comdata.code,
            memo: `${vm.comdata.service}-中金支付`,
          },
          function (result) {
            if (result.rcode == "000000") {
              
              //添加历史记录
              window.history.pushState("", null, "");
              const { walletUserId, paymentCode, payeeWalletId } = result.rdata;
              localStorage.setItem("pCode", paymentCode);
              const { service, code, amount } = vm.comdata;
              let url = `${
                api.NODE_ENV === "production"
                  ? "https://pay.izhaowo.com"
                  : "http://test3.rd.izhaowo.com:26085"
              }/pc/#/payPage?serialNumber=${paymentCode}&amount=${(
                amount / 100
              ).toFixed(
                0
              )}&name=${service}&order=${code}&walletAcountId=${payeeWalletId}&&pageMode=2`;
              window.payUrl = url
              vm.closeLayer(3, 2);
            } else {
              vm.$message.error(result.rdesc);
            }
            return;
          },
          function () {
            vm.$message.error("网络连接异常，请稍后重试");
          }
        );
      } else {
        vm.closeLayer(3, 2);
        //添加历史记录
        window.history.pushState("", null, "");
        //code
        let url = api.PAY_URL + "cashier?code=" + vm.comdata.code;
        window.open(url);
      }
    },
    closeLayer: function (type1, type2) {
      this.bus.$emit("comBox", 2); //弹出框框
      this.$emit("chanLayer", { cuindex: 2, menuIndex: type1, comBox: type2 }); //弹出框框
    },
  },
};
</script>



// WEBPACK FOOTER //
// comfirm-info.vue?36e37de2